import axios from 'axios';
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import config from '../../config/config';
import constant from '../../utils/Constant';

const {
    DASHBOARD_END_POINT,
    STATUS_200,
    STATUS_401,
    LOGOUT,
} = constant;


function Dashboard() {
    const navigate = useNavigate();

    const [data, setData] = useState([]);

    // * get token from local storage
    const token = localStorage.getItem('vendor_super_token');

    // * execute dashboard api
    const executeDashboardApi = useCallback(async () => {
        try {
            const apiUrl = config.appBaseUrl + DASHBOARD_END_POINT;

            // * execute get request
            const response = await axios.get(apiUrl, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            // * api response
            const result = response.data;

            // * if response is success
            if (result.code === STATUS_200 && result.status) {
                setData(result.data);
            }
        } catch (error) {
            toast.error(error.response?.data?.message);
            // * if token is expired
            if (error.response?.data?.code === STATUS_401) {
                navigate(LOGOUT);
            }
        }
    }, [navigate, token]);

    // * execute vendor detaits api
    useEffect(() => {
        executeDashboardApi();
    }, [executeDashboardApi, token]);

    // * vendor card data
    const vendorData = [
        { count: data.totalVendor, label: 'Total Vendor' },
        { count: data.pendingVendors, label: 'Total Pending Vendor' },
        { count: data.approvedVendor, label: 'Total Approved Vendor' },
        { count: data.rejectedVendor, label: 'Total Rejected Vendor' }
    ];

    return (
        <>
            <ToastContainer autoClose={700} position='top-center' />
            <div className='page-content'>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className='page-title-box d-flex align-items-center justify-content-between'>
                                <h4 className='mb-0'>Dashboard</h4>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-xl-12'>
                            <div className='row'>
                                {vendorData.map((item, index) => (
                                    <div className='col-xl-4 col-md-4' key={index}>
                                        <div className='card'>
                                            <div className='card-body p-0'>
                                                <div className='p-4'>
                                                    <div className='d-flex'>
                                                        <div className='flex-1'>
                                                            <h3 className='mb-3'>
                                                                <span className='counter_value'>{item.count}</span>
                                                            </h3>
                                                        </div>
                                                        <div>
                                                            <p className='badge badge-mint-green-lighten font-size-12'>Yearly</p>
                                                        </div>
                                                    </div>
                                                    <h5 className='text-muted font-size-14 mb-0'>{item.label}</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}
export default Dashboard;